import React from "react";
import ReactCountryFlag from "react-country-flag";
import { GiRotaryPhone } from "react-icons/gi";
import { FaUser } from "react-icons/fa"; // ← icono para usuario

const Flag = ({ code, number }) => {
  const isExtension = number?.length >= 2 && number?.length <= 5;
  const isUser = code === "USR"; // ← detecta si viene marcado como User

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "2.5em",
        height: "2.5em",
      }}
    >
      {isExtension ? (
        // 📞 Extensión interna
        <GiRotaryPhone
          style={{
            width: "3em",
            height: "1.3em",
            color: "#6B7280",
          }}
        />
      ) : isUser ? (
        // 👤 Usuario detectado
        <FaUser
          style={{
            width: "1.5em",
            height: "1.5em",
            color: "#374151",
          }}
        />
      ) : (
        // 🇺🇸 Bandera por defecto
        <ReactCountryFlag
          countryCode={code || "WLD"}
          style={{
            width: "3em",
          }}
          svg
        />
      )}
    </div>
  );
};

export default Flag;